import { z } from "zod";
import { DTOObjectMeta } from "../aux";

//
// Read
//

export const DTODesignSystemComponent = z.object({
  id: z.string(),
  persistentId: z.string(),
  designSystemVersionId: z.string(),
  brandId: z.string(),
  meta: DTOObjectMeta,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export const DTODesignSystemComponentResponse = z.object({
  designSystemComponent: DTODesignSystemComponent,
});

export const DTODesignSystemComponentListResponse = z.object({
  designSystemComponents: DTODesignSystemComponent.array(),
});

export type DTODesignSystemComponent = z.infer<typeof DTODesignSystemComponent>;
export type DTODesignSystemComponentResponse = z.infer<typeof DTODesignSystemComponentResponse>;
export type DTODesignSystemComponentListResponse = z.infer<typeof DTODesignSystemComponentListResponse>;

//
// Write
//

export const DTODesignSystemComponentCreateInput = z.object({
  brandId: z.string(), // Persistent ID,
  persistentId: z.string(),
  meta: DTOObjectMeta,
});

export type DTODesignSystemComponentCreateInput = z.infer<typeof DTODesignSystemComponentCreateInput>;
